module.exports = __webpack_public_path__ + "img/videoposter10.2db3ca60.jpg";